import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

const RadioFiled = (props) => {
  const { field, form, label, placeholder, options } = props;
  const { name, value, onChange, onBlur } = field;

  const [valueState, setValueState] = React.useState(value);

  const handleChange = (event) => {
    onChange(event);
    setValueState(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label={placeholder}
        name={name}
        {...field}
        value={valueState}
        onChange={handleChange}
      >
        {options.map((item, index) => {
          return (
            <FormControlLabel
              key={index}
              value={item.value}
              control={<Radio />}
              label={item.name}
              disabled={item.disabled}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

RadioFiled.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,

  label: PropTypes.string,
  options: PropTypes.array,
};

RadioFiled.defaultProps = {
  label: "",
  placeholder: "",
  options: [],
};

export default RadioFiled;
